import { render, staticRenderFns } from "./ModalRequestEditEmas.vue?vue&type=template&id=32d9f5c6&scoped=true&"
import script from "./ModalRequestEditEmas.vue?vue&type=script&lang=js&"
export * from "./ModalRequestEditEmas.vue?vue&type=script&lang=js&"
import style0 from "./ModalRequestEditEmas.vue?vue&type=style&index=0&id=32d9f5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9f5c6",
  null
  
)

export default component.exports